import { render, staticRenderFns } from "./ArticleTag.vue?vue&type=template&id=bab76c3a&scoped=true&"
import script from "./ArticleTag.vue?vue&type=script&lang=js&"
export * from "./ArticleTag.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTag.vue?vue&type=style&index=0&id=bab76c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab76c3a",
  null
  
)

export default component.exports